import React, { useState } from 'react'
import Image from 'next/image'
import Link from 'next/link'

import { Col, Row } from 'react-bootstrap'
import Axilor from '@/assets/about-us/our-investors/axilor-logo.png'
import Fjlabs from '@/assets/about-us/our-investors/fjlabs.webp'
import Fundamental from '@/assets/about-us/our-investors/foundamental-logo.png'

import Rigel from '@/assets/about-us/our-investors/rigel-logo.png'
import Rtp from '@/assets/about-us/our-investors/rtp.webp'
import StrideOne from '@/assets/finance/lending/stride-one.webp'
import Capsave from '@/assets/finance/lending/capsave.png'
import NorthernArc from '@/assets/finance/lending/northern-arc.png'
import Credable from '@/assets/finance/lending/credable.png'

import IciciBank from '@/assets/about-us/lending-partners/icici-bank.webp'
import IdfcFirstBank from '@/assets/about-us/lending-partners/idfc-first-bank.webp'
import Kotak from '@/assets/about-us/lending-partners/kotak.webp'
import mbookPlus from '@/assets/finance/lending/mbook-plus.webp'
import SbmbBank from '@/assets/about-us/lending-partners/sbm-bank.webp'
import Stride from '@/assets/about-us/lending-partners/stride.webp'
import Trifecta from '@/assets/about-us/lending-partners/trifecta.webp'
import YesBank from '@/assets/about-us/lending-partners/yes-bank.webp'
import { ReactGAEvent } from '@/components/ReactGAs'

// import Karza from '@/assets/about-us/technology-partners/karza.webp'
// import Perfios from '@/assets/about-us/technology-partners/perfios.webp'
// import Veefin from '@/assets/about-us/technology-partners/veefin.webp'

const category = [{ name: 'Investors' }, { name: 'Financial Partners' }]
const revenueData = [
	{ title: '5X', description: 'Revenue Growth Rate (FY 23-24)' },
	{ title: '650k+', description: 'Total Enquiries recorded (in MT)' },
	{ title: '4500+', description: 'Total Stakeholders Connected' },
	{ title: '100+', description: 'Total Categories Served' },
	{ title: '120+', description: 'Total Employees' },
	{ title: '26%', description: 'Female Employees' },
]

const investorsPartners = [
	{ img: Rigel, href: 'https://rigelcapital.com' },
	{ img: Axilor, href: 'https://www.axilor.com' },
	{ img: Fundamental, href: 'https://www.foundamental.com' },
	{ img: Fjlabs, href: 'https://www.fjlabs.com' },
	{ img: Rtp, href: 'https://rtp.vc' },
]
const lendingPartners = [IciciBank, IdfcFirstBank, Kotak, SbmbBank, Stride, Trifecta, YesBank, mbookPlus, StrideOne, Capsave, NorthernArc, Credable]

const OurInvestors = () => {
	const [selectInvestor, setSelectInvestor] = useState(0)

	const clickGAHandler = (event) => {
		ReactGAEvent({ action: 'action', event, label: 'Button' })
	}
	
	return (
		<>
			<div className='our-investors'>
				<div className='our-investors-heading'>
					<div className='heading-wapper'>
						<Col>
							<h1 className='heading text-center'>Our Partners</h1>
							<p className='paragraph'>
								Our journey is powered by a group of strategic investors who share our vision to revolutionize the Metal Supply Chain.
								With their unwavering support, Metalbook strides confidently towards reshaping the Industry Landscape, paving the way
								for a more Efficient and Sustainable future.
							</p>
						</Col>
						<Col>
							<div className='scroll-tab justify-content-center'>
								{category?.map((item, index) => (
									<div
										className={`fw-medium cursor-pointer category ${
											selectInvestor === index
												? 'scroll-selected-tab border-0 btn-primary'
												: 'scroll-disabled-tab secondary-border'
										}`}
										variant='outline-dark'
										size='sm'
										key={`inverstor-${index}`}
										onClick={() => {
											setSelectInvestor(index)
											index == 0 ? clickGAHandler('Investor') : clickGAHandler('Financial Partner')
										}}
									>
										{item?.name}
									</div>
								))}
							</div>
						</Col>
					</div>
				</div>
				<div className='investors-list'>
					<Row className='w-100 justify-content-center'>
						{selectInvestor === 0 &&
							investorsPartners?.map((item, index) => (
								<Col xs={6} md={3} lg={2} key={`${index}-lending-partners`}>
									<Link href={item.href} target='_blank'>
										<Image src={item.img} className='w-100 object-fit-contain' alt='...' />
									</Link>
								</Col>
							))}
						{selectInvestor === 1 &&
							lendingPartners?.map((item, index) => (
								<Col xs={6} md={3} lg={2} key={`${index}-lending-partners`}>
									<Image src={item} className='w-100 object-fit-contain' alt='...' />
								</Col>
							))}
					</Row>
				</div>
				{/* <Container>
					<Row>
						<h1 className='heading text-center mb-5'>Metalbook in Numbers</h1>

						{revenueData?.map((item, index) => (
							<Col xs={6} md={6} lg={4} key={`${index}`} className='investors-list-wapper d-flex'>
								<div className='investors-price investors-list-card'>
									<Card className='border-0 rounded-4'>
										<Card.Header className='border-0 bg-transparent'>
											<h2 className='primary-text'>{item?.title}</h2>
										</Card.Header>
										<Card.Body className='pt-0'>
											<p>{item?.description}</p>
										</Card.Body>
									</Card>
								</div>
							</Col>
						))}
					</Row>
				</Container> */}
			</div>
		</>
	)
}

export default OurInvestors
